import { computed, observable } from 'mobx'

import { PickPointLocation } from 'sections/LKSection/modules/OrderModule/types'
import {
  PickPointFileItemType,
  PickPointType,
  PickPointVideoItemType,
} from 'sections/LKSection/shared/PickPointSharedModule/types'
import { getMedia } from 'sections/LKSection/shared/PickPointSharedModule/utils'
import { Entity } from 'shared/stores/BaseStore'

import { EditAreaStatus } from '../../types/types'
import { PvzDTO } from '../../types/typesDTO'

export class Pvz extends Entity {
  @observable district = ''
  @observable name = ''
  @observable latitude = ''
  @observable longitude = ''

  @observable externalId = 0
  @observable rate = 0
  @observable isActive = true
  @observable blockTime = ''
  @observable description = ''
  @observable courierWay = ''
  @observable alarmSystem = ''
  @observable dressingRoomsCount = ''
  @observable timetable = ''
  @observable area = ''
  @observable warehouseArea = ''
  @observable editAreaStatus = EditAreaStatus.none
  @observable typePoint: PickPointType = PickPointType.none
  @observable floorLevel: PickPointLocation = PickPointLocation.firstFloor
  @observable shard = 0
  @observable racksCount = ''
  @observable cellsCount = ''
  @observable maxCellsCount = ''
  @observable features: string[] = []

  @observable photos: PickPointFileItemType[] = []
  @observable videos: PickPointVideoItemType[] = []
  @observable documents: PickPointFileItemType[] = []

  /* Здесь перечислены свойства, которых нет в DTO модели */
  constructor(props: Omit<Pvz, 'address'>) {
    super(props)
    Object.assign(this, props)
  }

  static create({ actualUrls, ...other }: PvzDTO) {
    const { videos, photos, documents } = getMedia(actualUrls)

    return new Pvz({
      ...other,
      videos,
      photos,
      documents,
      warehouseArea: other.stockArea,
      editAreaStatus: other.requestedAreaStatus,
      floorLevel: other.locations?.[0] ?? PickPointLocation.none,
    })
  }

  @computed
  get address() {
    if (!this.district || this.district.trim?.().length === 0) {
      return this.name
    }

    return `${this.district}, ${this.name}`
  }
}
